export enum InvalidationType {
    Tag = 'tag',
    Path = 'path',
    All = 'all',
}
